export default __webpack_public_path__ + "static/media/model-3-hero-desktop.5b06f4d2.jpg";